import React, { useState } from 'react';
import { Box, Grid, Typography } from '@material-ui/core';
import dayjs from 'dayjs';
import { useLocale } from 'hooks';

import { CalendarIcon, CameraIcon, InstallerIcon, LocationIcon, MeterIcon, SuccessIcon } from 'ui/icons';
import { useStyles as useMainStyles } from '../DesktopAssetsDetails.styles';
import { InfoBlock, ZoomableImage, LocationModal } from 'ui';
import { Asset } from 'hooks/useAssets/useAssets.types';

import { useStyles } from './InstallerDetails.styles';

export const InstallerDetails = ({
  installer,
  digitalMeter,
  address,
  latitude,
  longitude,
  dateOfInstallation,
  installationPhoto,
}: Asset) => {
  const mainClasses = useMainStyles();
  const classes = useStyles();
  const { formatMessage } = useLocale();
  const [isMapVisible, setMapVisible] = useState(false);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <InfoBlock
            className={mainClasses.box}
            items={[
              {
                text: installer?.name ?? '',
                label: formatMessage({ id: 'asset_details.installer' }),
                textIcon: InstallerIcon,
                labelIcon: SuccessIcon,
              },
              {
                text: dateOfInstallation ? dayjs(dateOfInstallation).format('YYYY-MM-DD') : '',
                label: formatMessage({ id: 'asset_details.dateOfInstallation' }),
                textIcon: CalendarIcon,
                labelIcon: SuccessIcon,
              },
            ]}
          />
        </Grid>
        <Grid item xs={12}>
          <InfoBlock
            className={mainClasses.box}
            items={[
              {
                text: digitalMeter ?? '',
                label: formatMessage({ id: 'asset_details.eanMeter' }),
                textIcon: MeterIcon,
                labelIcon: SuccessIcon,
              },
            ]}
          />
        </Grid>
        <Grid item xs={12}>
          <InfoBlock
            className={mainClasses.box}
            onClick={() => setMapVisible(true)}
            items={[
              {
                text: address ?? '',
                label: formatMessage({ id: 'asset_details.location' }),
                textIcon: LocationIcon,
                labelIcon: SuccessIcon,
                content: (
                  <Box display="flex" alignItems="flex-end">
                    <Typography className={classes.showMap}>Show map</Typography>
                  </Box>
                ),
              },
            ]}
          />
        </Grid>
        <Grid item xs={12}>
          <InfoBlock
            className={mainClasses.box}
            items={[
              {
                text: formatMessage({ id: 'asset_details.clickToZoom' }),
                label: formatMessage({ id: 'asset_details.batteryInstallationPhoto' }),
                textIcon: CameraIcon,
                labelIcon: SuccessIcon,
                content: installationPhoto && <ZoomableImage src={URL.createObjectURL(installationPhoto)} />,
              },
            ]}
          />
        </Grid>
      </Grid>
      <LocationModal
        handleClose={() => setMapVisible(false)}
        isOpened={isMapVisible}
        longitude={longitude ?? 0}
        latitude={latitude ?? 0}
      />
    </>
  );
};
